module.exports = __webpack_public_path__ + "img/friss_logo.552e9af9.png";